
import React from 'react';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
import {BoxplotChart} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

class BubbleSample extends React.Component {
    _onClick(currentValue) {
        this.props.onSubmit(currentValue)
    }
    render() {
        const {dataNames} = this.props;
        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        let finalObjectFiltered = []
        let finalNameFiltered = []
        this.props.dataObject.forEach((input, index) => {
            if (this.props.dataNames[`positiontype${index + 1}`] === "Number") {
                finalObjectFiltered.push(input)
                finalNameFiltered.push(dataNames[`positionname${index+1}`])
            }
        })
        console.log(this.props.dataObject)
        return (
            <div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h2><strong>Outliers</strong></h2>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button label='Next'
                            type='submit'
                            primary={true}
                            onClick={this._onClick.bind(this)} 
                        />
                    </Box>
                </div>
                <hr style={{width: "100%"}} />
                <BoxplotChart data={finalObjectFiltered} names={finalNameFiltered}/>
            </div>
        );
    }
}

export default BubbleSample;


// WEBPACK FOOTER //
// ./src/samples/run/boxplotrun.js